import { Link } from './link.model';
export class User {
    $key:string;
    name:string;
    email:string;
    socialLogin:string;
    socialLink:Link[];
}
